import { IconBookmark } from '@justeattakeaway/pie-icons-react';
import PIENotification, {
  IPieNotificationMode,
} from '@src/shared/components/PIENotification';
import PIEText from '@src/shared/components/PIEText';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface componentProps {
  comment: string;
}

export const OrderDetailUserComment = ({ comment }: componentProps) => {
  const { t } = useTranslation();
  return (
    <PIENotification
      isOpen={true}
      showClose={false}
      mode={IPieNotificationMode.Info}
      modInline={true}
      icon={<IconBookmark size={'m'} />}
    >
      <PIEText
        text={t('order.order_detail_customer_notes')}
        size="var(--xds-font-size-16)"
        fontWeight="var(--xds-font-weight-bold)"
        color="var(--xds-color-content-default)"
      />
      <PIEText
        text={comment}
        size="var(--xds-font-size-16)"
        fontWeight="var(--xds-font-weight-regular)"
        color="var(--xds-color-content-default)"
      />
    </PIENotification>
  );
};

export default OrderDetailUserComment;
